import React from "react"
import { useState, useCallback, useContext } from "react"
import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'

export default ({ text = "Pendify Dodone", dodone, pendifyDodone, updateDodone }) => {
  if(!dodone || !dodone.isIgnored) return null

  return <div className="input-group">
           <ConfirmableSpinnableButton className="btn btn-danger btn-block" onConfirm={ pendifyDodone } isSpinning={ updateDodone.isPending }>
             { text }
           </ConfirmableSpinnableButton>
         </div>
}
